(()=>{
  const setup=section=>{
    if(!section||section.dataset.stackReady==='true')return;
    section.dataset.stackReady='true';
    section.classList.add('pw-stack-ready');
    const items=[...section.querySelectorAll('[data-package-reveal]')];

    if(!('IntersectionObserver'in window)){
      items.forEach(item=>item.classList.add('is-visible'));
      return;
    }

    const observer=new IntersectionObserver(entries=>{
      entries.forEach(entry=>{
        if(!entry.isIntersecting)return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },{threshold:.08,rootMargin:'0px 0px -4% 0px'});

    items.forEach(item=>observer.observe(item));
  };

  document.querySelectorAll('[data-package-stack]').forEach(setup);
  document.addEventListener('shopify:section:load',event=>{
    const section=event.target.querySelector?.('[data-package-stack]');
    setup(section);
  });
})();
